var render = function render(_c,_vm){return _c('svg',_vm._g(_vm._b({staticClass:"icon info",class:[_vm.data.class, _vm.data.staticClass],attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14"}},'svg',_vm.data.attrs,false),_vm.listeners),[_c('path',{attrs:{"d":"M7 0a1 1 0 1 0 1 1c0-.551-.449-1-1-1M7 4c-.552 0-1 .56-1 1.25v7.5c0 .69.448 1.25 1 1.25s1-.56 1-1.25v-7.5C8 4.56 7.552 4 7 4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }